import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { createBookingSession } from "../api/createBookingSession";

export const useCreateBookingSession = () => {
  const { t } = useTranslation(["booking"]);

  return useMutation({
    mutationFn: createBookingSession,
    onError: (err: any) => {
      toast.error(
        err.response?.data?.message ?? t("booking:notifications.create_error"),
      );
    },
  });
};
